/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetStatisticsQueryResponse, HierarchiesControllerGetStatisticsPathParams, HierarchiesControllerGetStatisticsQueryParams, HierarchiesControllerGetStatistics400, HierarchiesControllerGetStatistics401, HierarchiesControllerGetStatistics403, HierarchiesControllerGetStatistics404 } from "../../models/hierarchiesController/HierarchiesControllerGetStatistics";

function getHierarchiesControllerGetStatisticsUrl(scopeId: HierarchiesControllerGetStatisticsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/stats` as const }  
  return res
}

/**
 * @description Get statistical information about the scope including member counts and child entity counts
 * @summary Get scope statistics
 * {@link /api/v1/hierarchies/:scopeId/stats}
 */
export async function hierarchiesControllerGetStatistics(scopeId: HierarchiesControllerGetStatisticsPathParams["scopeId"], params: HierarchiesControllerGetStatisticsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetStatisticsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetStatistics400 | HierarchiesControllerGetStatistics401 | HierarchiesControllerGetStatistics403 | HierarchiesControllerGetStatistics404>, unknown>({ method : "GET", url : getHierarchiesControllerGetStatisticsUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}